// UsageData.js
import React, { useState, useEffect } from 'react';
import './styles.css';
import axios from 'axios';
import HeaderLogged from './HeaderLogged';
import Sidebar from './Sidebar';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const UsageData = () => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [usageData, setUsageData] = useState([]);
  const [companyID, setCompanyID] = useState(null);

  useEffect(() => {
    // Verificar se o usuário está logado
    const userData = localStorage.getItem("user");
    if (!userData) {
      window.location.href = "/";
    } else {
      const data = JSON.parse(userData);
      setCompanyID(data.companyID);
    }
  }, []);

  const fetchUsageData = async () => {
    if (!companyID || !startDate || !endDate) {
      alert("Por favor, preencha todos os campos.");
      return;
    }

    try {

      const requestBody = new FormData();
      requestBody.append('companyID', companyID);
      requestBody.append('startDate', startDate ? startDate.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' }) : '');
      requestBody.append('endDate', endDate ? endDate.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' }) : '');
      
      
      const response = await axios.post(
        process.env.REACT_APP_BASE_URL + '/api/ReturnUsageData',
        requestBody
      );

      if (response.status === 200) {
        setUsageData(response.data);
      } else {
        alert("Erro ao buscar dados de uso.");
      }
    } catch (error) {
      console.error(error);
      alert("Erro ao buscar dados de uso." + error);
    }
  };

  return (
    <div className='container-fluid p-0'>
      <HeaderLogged />
      <div className="row showContentMargin" id='content'>
        <div className="col-3 col-lg-auto col-xxl-2" id='divSidebar'>
          <Sidebar />
        </div>
        <main className="container col-lg-10 col-xxl-9 p-4" id='divContent'>
          <div className="row mb-4">
            <div className="col-md-4">
              <label htmlFor="startDate">Data de Início:</label>
              <DatePicker
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                className="form-control"
                dateFormat="yyyy-MM-dd"
                placeholderText="Selecione a data de início"
              />
            </div>
            <div className="col-md-4">
              <label htmlFor="endDate">Data de Fim:</label>
              <DatePicker
                selected={endDate}
                onChange={(date) => setEndDate(date)}
                className="form-control"
                dateFormat="yyyy-MM-dd"
                placeholderText="Selecione a data de fim"
              />
            </div>
            <div className="col-md-4">
              <button className="btn btn-primary mt-4" onClick={fetchUsageData}>
                Buscar Dados
              </button>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              {/* Exibir dados de uso em um grid */}
              {usageData.length > 0 ? (
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th>Mês</th>
                      <th>Descrição</th>
                      <th>Contador</th>
                    </tr>
                  </thead>
                  <tbody>
                    {usageData.map((dataItem, index) => (
                      <tr key={index}>
                        <td>{dataItem.Month}</td>
                        <td>{dataItem.Description}</td>
                        <td>{dataItem.Counter}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <p>Nenhum dado encontrado.</p>
              )}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default UsageData;
